import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const target = location.pathname === "/admin" ? "/admin" : "/";
    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        window.history.replaceState(null, "", target);
        navigate(target, { replace: true, state: { user: data, justSignedIn: true } });
      } catch {
        window.history.replaceState(null, "", target);
        navigate(target, { replace: true, state: { authError: true } });
      }
    })();
  }, [location.hash, location.pathname, navigate]);

  return (
    <div
      data-testid="auth-callback-loading"
      className="flex min-h-screen items-center justify-center bg-mist font-manrope text-sm font-semibold text-forest/50"
    >
      Signing you in…
    </div>
  );
}
